 <!-- 組件的模板 -->
<div class="modal-header">
    <h5 class="modal-title">圖片上傳</h5>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <!-- 組件的內容 -->
    <div>
        <input type="file" (change)="fileChangeEvent($event)" />
    </div>

    <div class="img-cropper">
        <image-cropper
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="false"
            [aspectRatio]="1 / 10"
            format="png"
            (imageCropped)="imageCropped($event)"
            (imageLoaded)="imageLoaded()"
            (cropperReady)="cropperReady()"
            (loadImageFailed)="loadImageFailed()"
        ></image-cropper>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="sendDataBack()">確定</button>
    <button type="button" class="btn btn-primary" (click)="closeModal()">取消</button>
</div>